import { Button, Flex, Space, Text } from '@mantine/core';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import { useTranslation } from 'react-i18next';

export const MeasurementSelector = ({
  measurementDate,
  isLatest,
  onClickLeft,
  onClickRight,
  hideLeft,
  hideRight,
}: {
  measurementDate: string;
  isLatest: boolean;
  onClickLeft: () => void;
  onClickRight: () => void;
  hideLeft: boolean;
  hideRight: boolean;
}) => {
  const { t } = useTranslation(['common', 'reports']);

  return (
    <Flex direction={'row'} justify={'space-between'}>
      <Flex direction={'column'} justify={'center'}>
        {hideLeft ? (
          <Space w={26} />
        ) : (
          <Button
            variant="inline-text"
            leftSection={
              <ArrowBackIosOutlinedIcon
                style={{
                  fontSize: 'var(--mantine-fontSize-sm)',
                  color: '#000',
                }}
              />
            }
            onClick={onClickLeft}
          />
        )}
      </Flex>
      <Text style={{ color: '#000' }}>
        {isLatest && t('reports:current_measurement')} {measurementDate}
      </Text>
      <Flex direction={'column'} justify={'center'}>
        {hideRight ? (
          <Space w={26} />
        ) : (
          <Button
            variant="inline-text"
            rightSection={
              <ArrowForwardIosOutlinedIcon
                style={{
                  fontSize: 'var(--mantine-fontSize-sm)',
                  color: '#000',
                }}
              />
            }
            onClick={onClickRight}
          />
        )}
      </Flex>
    </Flex>
  );
};
